import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { FaBars } from 'react-icons/fa';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';

var Main = function Main(_ref) {
  var handleToggleSidebar = _ref.handleToggleSidebar,
      handleImageChange = _ref.handleImageChange,
      children = _ref.children;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';
  return /*#__PURE__*/_jsxs("main", {
    className: "min-vh-100 h-100",
    dir: isRTL ? 'rtl' : 'ltr',
    style: {
      fontFamily: isRTL ? 'Yekan' : 'Helvetica'
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: "btn-toggle",
      onClick: function onClick() {
        return handleToggleSidebar(true);
      },
      children: /*#__PURE__*/_jsx(FaBars, {})
    }), children]
  });
};

export default Main;